import { MediaLimits, MediaType, ValidationResult } from '../../system/media';

interface ValidationResultsContentProps {
  result: ValidationResult;
  type: MediaType;
  currentCount: number;
  config: MediaLimits;
}

function toDisplayValue(type: MediaType) {
  switch (type) {
    case MediaType.Photo:
      return 'image';
    case MediaType.Tour:
      return 'tour';
    case MediaType.Document:
      return 'document';
  }
  return 'file';
}

const ValidationResultsContent: React.FC<ValidationResultsContentProps> = ({
  result,
  type,
  currentCount,
  config,
}) => {
  return (
    <div className="space-y-4">
      {result.nameFailures?.length > 0 && (
        <div className="space-y-2">
          <h4 className="font-semibold text-lg">File Name Too Long</h4>
          <div className="text-sm text-gray-600">
            Document names must be 50 characters or less (excluding file
            extension). The following files have names that are too long:
          </div>
          <ul className="list-disc pl-4">
            {result.nameFailures.map((failure) => (
              <li key={failure.file.name} className="text-sm">
                {failure.file.name}
              </li>
            ))}
          </ul>
        </div>
      )}

      {result.countFailures.length > 0 && (
        <div className="space-y-2">
          <h4 className="font-semibold text-lg">Upload Limit Reached</h4>
          <div className="text-sm text-gray-600">
            You can upload a maximum of {config.count}{' '}
            {toDisplayValue(type) + 's'} per listing. You have already uploaded{' '}
            {currentCount} {toDisplayValue(type) + 's'}. To upload more, please
            delete one or more existing images from this listing and please try
            again. <br />
            <br />
            The following {toDisplayValue(type) + 's'} cannot be uploaded as
            they would exceed the {config.count} {toDisplayValue(type)} limit:
          </div>
          <ul className="list-disc pl-4">
            {result.countFailures.map((failure) => (
              <li key={failure.file.name} className="text-sm">
                {failure.file.name}
              </li>
            ))}
          </ul>
        </div>
      )}

      {result.sizeFailures.length > 0 && (
        <div className="space-y-2 mt-4">
          <h4 className="font-semibold text-lg">File Size Limit Exceeded</h4>
          <div className="text-sm text-gray-600">
            The file(s) you are trying to upload is too large. The following
            file(s) exceed the {result.sizeFailures[0].limit} limit and cannot
            be uploaded:
          </div>
          <ul className="list-disc pl-4">
            {result.sizeFailures.map((failure) => (
              <li key={failure.file.name} className="text-sm">
                {failure.file.name} (
                {(failure.file.size / (1024 * 1024)).toFixed(2)}MB)
              </li>
            ))}
          </ul>
        </div>
      )}

      {result.validFiles.length > 0 && (
        <div className="mt-6 text-sm text-blue-600">
          You may still proceed to upload the other {result.validFiles.length}{' '}
          {toDisplayValue(type) + 's'}.
        </div>
      )}
    </div>
  );
};

export default ValidationResultsContent;
